export class Myact {
    agent_act_id: number;
    ag_contract_header_id: number;
    act_uuid: string;
    sign_report: number;
    createdAt: Date;
    pay_day: Date;
    date_begin: Date;
    date_end: Date;
}